import { IInputElement } from '../../types';

import { InputTextElement } from '../../form-inputs';

type TFullNameInputProps = Pick<
  IInputElement,
  | 'constraints'
  | 'editable'
  | 'error'
  | 'label'
  | 'isLabelEnabled'
  | 'name'
  | 'onBlurCallback'
  | 'onChangeCallback'
  | 'onError'
  | 'placeholder'
  | 'value'
>;

/**
 * -----------------------------------------------------------------------------
 * This is used to capture the full name of a person or organization,
 * and tries to add constraints that are used to validate the expected format of
 * a valid person's full name.
 */
export function FullNameInputField({
  constraints = {},
  editable,
  error,
  label,
  isLabelEnabled,
  name,
  onBlurCallback,
  onChangeCallback,
  onError,
  placeholder,
  value,
}: TFullNameInputProps) {
  return (
    <InputTextElement
      constraints={{
        feedbackLabel: 'The full name',
        maxLength: 80,
        minLength: 3,
        required: true,
        format: 'person-fullname',
        ...constraints,
      }}
      editable={editable}
      error={error}
      hasClearButton
      isLabelEnabled={isLabelEnabled}
      label={label}
      name={name}
      onBlurCallback={onBlurCallback}
      onChangeCallback={onChangeCallback}
      onError={onError}
      placeholder={placeholder || 'Name'}
      showIsRequired={false}
      type="text"
      value={value}
    />
  );
}
